module.exports = ".wrapper{\r\n    border:1px solid #ccc;\r\n}\r\n\r\n.card-body{\r\n    padding:10px;\r\n}\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.btn-block{\r\n    font-size:14px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/technical/billing/tender-bill/tender-bill-form/tender-bill-form.component.css
// module id = ./src/app/technical/billing/tender-bill/tender-bill-form/tender-bill-form.component.css
// module chunks = main